import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { AvatarModal } from './style';

import {
  getUser,
  uploadAvatarImage,
  setImageAvatar,
  createCrops
} from '../../../../utils/apiUser';

import {
  selectAvatar,
  selectAvatarAxis
} from '../../../../constants/avatarIcons';

import { API } from '../../../../constants/api';

import ChangeImage from './ChangeImage';

const ModalAvatar = ({ hideEditAvatar }) => {
  const [user, setUser] = useState(null);
  const [avatar, setAvatarPR] = useState(null);

  useEffect(() => {
    getUser().then(data => {
      setUser(data);
      setAvatarPR(data.avatarId);
    });
  }, []);

  return (
    <AvatarModal
      isMaxWidth
      isMaxHeight={false}
      clickCloseIcon={() => {
        hideEditAvatar();
      }}
    >
      {user && (
        <ChangeImage
          user={user}
          userAvatarData={{
            userName: user && `${user.name} ${user.lastname}`,
            imgAvatar: !avatar
              ? selectAvatar(user.avatarId)
              : selectAvatar(avatar),
            type: !avatar
              ? selectAvatarAxis(user.avatarId)
              : selectAvatarAxis(avatar),
            perfil: `${API}images/avatar/${user && user.userId}/128x128.jpg`
          }}
          uploadAvatarImage={uploadAvatarImage}
          setImageAvatar={setImageAvatar}
          createCrops={createCrops}
        />
      )}
    </AvatarModal>
  );
};

ModalAvatar.propTypes = {
  hideEditAvatar: PropTypes.func
};

export default ModalAvatar;
